export default __webpack_public_path__ + "static/media/cities.4a941772.svg";